module.exports = __webpack_public_path__ + "static/media/Restraint Bias.53b47130.jpg";